import { Euro } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Drawer,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { ManageInvestmentContext } from "../../pages/myInvestments";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import PercentIcon from "@mui/icons-material/Percent";
import NumbersIcon from "@mui/icons-material/Numbers";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FlagIcon from "@mui/icons-material/Flag";

function FilterOwnInvestments() {
  const {
    openDrawer,
    toggleDrawer,
    expanded,
    handlerChangeExpanded,
    filtersSettings,
    setFiltersSettings,
    handlerFilterSet,
    handlerResetFilters,
  } = useContext(ManageInvestmentContext);

  const formatNumberWithDots = (number) => {
    if (typeof number === "number") {
      number = `${number}`;
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");
    return rawValue;
  };

  return (
    <Drawer open={openDrawer} anchor="right" onClose={toggleDrawer(false)}>
      <Stack
        sx={{
          px: 2,
          py: 1,
          width: { xs: 270, md: 330 },
          position: "relative",
          height: "100%",
        }}
      >
        <Typography component="h2" variant="h5" mb={3}>
          Filtros
        </Typography>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel1"}
          onChange={handlerChangeExpanded("panel1")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <LocalActivityIcon />
              Inversión Mínima
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-price"
                label="Mínimo"
                type="text"
                autoComplete="off"
                sx={{
                  mb: 2,
                }}
                value={formatNumberWithDots(filtersSettings.price.min)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      price: {
                        ...filtersSettings.price,
                        min: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-price"
                label="Máximo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.price.max)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      price: {
                        ...filtersSettings.price,
                        max: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            mb: 2,
          }}
          expanded={expanded === "panel2"}
          onChange={handlerChangeExpanded("panel2")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <ShowChartIcon />
              Rentabilidad
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-profiabilty"
                label="Minimo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.profitability.min)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      profitability: {
                        ...filtersSettings.profitability,
                        min: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                sx={{
                  mb: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <PercentIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-profitability"
                label="Máximo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.profitability.max)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      profitability: {
                        ...filtersSettings.profitability,
                        max: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <PercentIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel3"}
          onChange={handlerChangeExpanded("panel3")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <AccessTimeIcon />
              Días restantes
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-days"
                label="Minimo"
                type="number"
                autoComplete="off"
                value={filtersSettings.days.min}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 3);
                    setFiltersSettings({
                      ...filtersSettings,
                      days: {
                        ...filtersSettings.days,
                        min: result ? parseInt(result) : "",
                      },
                    });
                  }
                }}
                sx={{
                  mb: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <NumbersIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-days"
                label="Máximo"
                type="number"
                autoComplete="off"
                value={filtersSettings.days.max}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 3);
                    setFiltersSettings({
                      ...filtersSettings,
                      days: {
                        ...filtersSettings.days,
                        max: result ? parseInt(result) : "",
                      },
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <NumbersIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel4"}
          onChange={handlerChangeExpanded("panel4")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel4-content"
            id="panel4-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <FlagIcon />
              Objetivo
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-objective"
                label="Minimo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.objective.min)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      objective: {
                        ...filtersSettings.objective,
                        min: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                sx={{
                  mb: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-objective"
                label="Máximo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.objective.max)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  if (/^\d*$/.test(result)) {
                    result = result.slice(0, 10);
                    setFiltersSettings({
                      ...filtersSettings,
                      objective: {
                        ...filtersSettings.objective,
                        max: result ? parseFloat(result) : "",
                      },
                    });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>

        {/* BOTONES DE ACCIÓN */}
        <Stack flexDirection="row" position="absolute" width="90%" bottom={10}>
          <Button sx={{ width: "50%" }} onClick={handlerResetFilters}>
            RESTABLECER
          </Button>
          <Button
            sx={{ width: "50%", color: "white", marginRight: 1 }}
            variant="contained"
            onClick={handlerFilterSet}
          >
            APLICAR
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

export default FilterOwnInvestments;
